import { defineStore } from 'pinia';

export const useSlideoutStore = defineStore('slideout', {
  state: () => ({
    expanded: {},
    slideout: {
      id: '',
      props: {},
      component: null,
      title: '',
    },
  }),
  getters: {
    allSlideoutsClosed: (state) => {
      return !Object.keys(state.expanded).filter((key) => state.expanded[key] === true).length;
    },
  },
  actions: {
    close(id) {
      this.expanded[id] = false;
    },
    open(id) {
      this.expanded[id] = true;
    },
    toggle(id) {
      this.expanded[id] = !this.expanded[id];
    },
    setSlideout(slideout) {
      this.slideout = slideout;
    },
  },
});
